/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Directory_Detail_Signals_Benchmark_SourceInputs */

const en_directory_detail_signals_benchmark_source = /** @type {(inputs: Directory_Detail_Signals_Benchmark_SourceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Measured by agent-readiness benchmark ${i?.version}`)
};

const zh_directory_detail_signals_benchmark_source = /** @type {(inputs: Directory_Detail_Signals_Benchmark_SourceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`由 agent-readiness 基准 ${i?.version} 实测`)
};

/**
* | output |
* | --- |
* | "Measured by agent-readiness benchmark {version}" |
*
* @param {Directory_Detail_Signals_Benchmark_SourceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_benchmark_source = /** @type {((inputs: Directory_Detail_Signals_Benchmark_SourceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Benchmark_SourceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_benchmark_source(inputs)
	return zh_directory_detail_signals_benchmark_source(inputs)
});
export { directory_detail_signals_benchmark_source as "directory.detail.signals.benchmark_source" }